import { getDeadlockImagePath } from "lib/general-helper";
import { Abilities } from "./BuildPageContainer";
import { Fragment } from "react";
import { TooltipContainer } from "@outplayed/tooltips";
import { ReactComponent as ArrowIcon } from "svg/arrow-right-line.svg";
import AbilityTooltip from "components/AbilityTooltip";

interface UnlockOrderProps {
  abilitiesByPickOrder: { abilityName: string }[];
  abilitiesBySlot: Abilities;
}

const UnlockOrder = (props: UnlockOrderProps) => {
  const { abilitiesByPickOrder, abilitiesBySlot } = props;

  // first, get an array of the unique names of abilities in the order of which they were selected
  const abilityNamesByPickOrder = Array.from(new Set(abilitiesByPickOrder.map((ability) => ability.abilityName)));

  // second, map those names to their actual slot number. output:
  // [
  //   { name: "Frost Grenade", index: 1, abilityImage: "image1" },
  //   { name: "Arctic Beam", index: 3, abilityImage: "image3" },
  //   { name: "Ice Path", index: 2, abilityImage: "image2" },
  //   { name: "Frozen Shelter", index: 4, abilityImage: "image4" }
  // ]
  const unlockOrder = abilityNamesByPickOrder.map((name) => {
    const key = Object.keys(abilitiesBySlot).find((key) => abilitiesBySlot[key].name === name);

    if (!key)
      return {
        name,
        index: null,
        abilityImage: "",
        description: "",
        stats: {},
        t1Desc: "",
        t2Desc: "",
        t3Desc: "",
        upgrades: {},
      };

    return {
      name,
      index: parseInt(key.replace("ability", "")),
      abilityImage: abilitiesBySlot[key].abilityImage,
      description: abilitiesBySlot[key].desc,
      stats: abilitiesBySlot[key].stats,
      t1Desc: abilitiesBySlot[key].t1Desc,
      t2Desc: abilitiesBySlot[key].t2Desc,
      t3Desc: abilitiesBySlot[key].t3Desc,
      upgrades: abilitiesBySlot[key].upgrades,
    };
  });

  return (
    <div className="unlock-order-wrapper">
      {unlockOrder.map((ability, index) => {
        const abilityImage = getDeadlockImagePath(ability.abilityImage, ability.name);

        return (
          <Fragment key={index}>
            <div className="skill-wrapper">
              <TooltipContainer
                tooltipInfo={
                  <AbilityTooltip
                    ability={{
                      name: ability.name,
                      description: ability.description,
                      abilityImage: ability.abilityImage,
                      stats: ability.stats,
                      t1Desc: ability.t1Desc,
                      t2Desc: ability.t2Desc,
                      t3Desc: ability.t3Desc,
                      upgrades: ability.upgrades,
                    }}
                  />
                }
              >
                <img
                  src={`https://static.bigbrain.gg/deadlock/staticdata/panorama/images${abilityImage}.png`}
                  alt={ability.name}
                />
              </TooltipContainer>
              <div className="order-number">{ability.index}</div>
            </div>
            {index < 3 && <ArrowIcon className="arrow-icon" />}
          </Fragment>
        );
      })}
    </div>
  );
};

export default UnlockOrder;
